import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-0 p-2 justify-content-center" }
const _hoisted_2 = ["src"]

import Api from "@/services/api"
    import { AdBanner } from "@/services/types/adBanner"
    import { ElDatePicker, ElInputNumber, ElMessage, ElMessageBox, FormInstance, FormRules } from "element-plus"
    import { computed, onBeforeMount, reactive, ref } from "vue"
    import { useRouter } from "vue-router"
    import { useStore } from "vuex"

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateAdBanner',
  setup(__props) {

    const store = useStore()
    const router = useRouter()
    const adBanner = reactive<AdBanner>({
        title: '',
        description: '',
        expires_at: new Date(),
        position: 1,
        small_text: '',
        id: 1,
        url: '',
    })

    const rules = reactive<FormRules<AdBanner>>({
        title: [{required: true, message: 'Insira o titulo', min: 1}],
        description: [{required: true, message: 'Informe a descricao'}],
        position: [{required: true, message: 'Posicao'}],
    })

    const fileInput = ref<HTMLInputElement>()
    const image = ref<File | Blob>()
    const formRef = ref<FormInstance>()
    const loading = ref<boolean>(true)

    onBeforeMount(async () => {
        loading.value = true
        
        loading.value = false
    })

    const uri = computed<string | undefined>(() => image.value && URL.createObjectURL(image.value))

    const selectImage = (e: Event) => {
        const target = e.target as HTMLInputElement
        if (target.files) {
            image.value = target.files[0]
        }
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        if (!image.value) {
            alert("Selecione imagem")
            return
        }
        await formEl.validate(async (valid) => {
            if (valid) {
                loading.value = true
                const data = new FormData()
                data.append('title', adBanner.title)
                image.value && data.append('image', image.value)
                data.append('description', adBanner.description)
                data.append('expires_at', adBanner.expires_at.toISOString())
                data.append('position', adBanner.position.toString())
                adBanner.small_text && data.append('small_text', adBanner.small_text)
                adBanner.url && data.append('url', adBanner.url)

                const res = await Api.post('admin/ad-banners', adBanner, data)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Propaganda cadastrada com sucesso'})
                    store.commit('setOpenModal', -1)
                    
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                loading.value = false
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createBlock(_component_el_skeleton, {
    rows: 12,
    loading: loading.value,
    animated: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (uri.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: uri.value,
              class: "col-8"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("input", {
        type: "file",
        name: "file",
        ref_key: "fileInput",
        ref: fileInput,
        onChange: selectImage
      }, null, 544),
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        disabled: loading.value,
        rules: rules,
        model: adBanner,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            prop: "title",
            label: "Titulo / Nome"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                name: "name",
                modelValue: adBanner.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((adBanner.title) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "expires_at",
            label: "Expira em"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElDatePicker), {
                type: "datetime",
                name: "expires_at",
                modelValue: adBanner.expires_at,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((adBanner.expires_at) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "position",
            label: "Ordem (posicao)"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElInputNumber), {
                min: 0,
                modelValue: adBanner.position,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((adBanner.position) = $event)),
                name: "position"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "small_text",
            label: "Texto curto / preco"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                name: "small_text",
                modelValue: adBanner.small_text,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((adBanner.small_text) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "url",
            label: "Link"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                name: "url",
                modelValue: adBanner.url,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((adBanner.url) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "description",
            label: "Descricao"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                name: "description",
                type: "textarea",
                modelValue: adBanner.description,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((adBanner.description) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            plain: "",
            loading: loading.value,
            size: "large",
            type: "primary",
            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (submit(formRef.value)), ["prevent"]))
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode(" Cadastrar ", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }, 8, ["disabled", "rules", "model"])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})